import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Container, Button, Input, UncontrolledTooltip } from 'reactstrap';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import { getSessions } from '../actions/Sessions';
import * as staticDataActions from '../actions/StaticData';
import * as actions from '../actions/Trainings';
import { getTrainingFaculty } from '../actions/Training';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteConfirmation from '../components/DeleteConfirmation';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import CloudOutlinedIcon from '@mui/icons-material/CloudOutlined';

class Trainings extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            currentSessionId: props.currentSessionId,
            showDeleteConfirmation: false,
            toDelete: []
        }
    }

    componentDidMount() {
        this.props.actions.getTrainings(this.props.currentSessionId);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.currentSessionId !== prevState.currentSessionId) {
            nextProps.actions.getTrainings(nextProps.currentSessionId);
        }
        return nextProps;
    }

    getRows() {
        const rows = [];
        this.props.trainings.forEach(training => {
            const { trainingId, projectName, trainingType, startDate, location, trainer } = training.toJS();
            rows.push(<tr training-id={trainingId} onClick={this.handleSelect}>
                <td>{projectName}</td>
                <td>{trainer}</td>
                <td>{new moment(startDate).format('MMMM Do YYYY, h:mm a')}</td>
                <td>{trainingType}</td>
                <td>{location}</td>
            </tr>)
        });
        return rows;
    }

    handleAdd = (e) => {
        const startDate = e.start;
        const endDate = e.end;
        this.props.actions.newTraining(startDate, endDate);
        this.props.history.push({
            pathname: `/trainings/training`
        });
    }

    handleSelect = (e) => {
        const trainingId = e.id;
        this.props.actions.getTraining(trainingId);
        this.props.actions.getTrainingFaculty(trainingId);
            this.props.history.push({
                pathname: `/trainings/training/${trainingId}`
            });
    };

    ColoredDateCellWrapper = ({ children }) =>
        React.cloneElement(React.Children.only(children), {
            style: {
                backgroundColor: 'lightblue',
            },
        })

    handleCalendarChange = (e, fromCalendar) => {
        if (!fromCalendar) {
            const { value } = e.target;
            const dayToUse = new Date(value);
            if (moment(dayToUse).isValid())
                this.setState({ selectedDay: moment(value).toDate() });
        }
        else
            this.setState({ selectedDay: e.toDate() });
    }

    toggleDeleteModal = (event) => {
        this.setState({ showDeleteConfirmation: !this.state.showDeleteConfirmation, toDelete: event });
    }

    handleDelete = () => {
        this.props.actions.deleteTrainings([this.state.toDelete.id], this.state.currentSessionId);
        this.setState({ showDeleteConfirmation: false });
    }

    render() {
        const { trainings } = this.props;
        const localizer = momentLocalizer(moment)
        const events = this.props.trainings.map(x => {
            return {
                title: x.get('trainingType'),
                id: x.get('trainingId'),
                start: new Date(x.get('startDate')),
                end: new Date(x.get('endDate'))
            }
        });
        const CustomEvent = (event) => {
            const filteredTraining = trainings.filter(x => x.get('trainingId') === event.event.id);
            const location = filteredTraining.map(item => item.get('trainingLocation')).toArray();
            const icon = [];
            if (location[0] === 'In Person')
                icon.push(<span id='inPerson'><LocationCityIcon />
                    <UncontrolledTooltip delay={{ show: 0, hide: 0 }} target='inPerson'>InPerson</UncontrolledTooltip>
                </span>
                );
            else if (location[0] === 'Virtual')
                icon.push(<span id='virtual'><CloudOutlinedIcon />
                    <UncontrolledTooltip delay={{ show: 0, hide: 0 }} target='virtual'>Virtual</UncontrolledTooltip>
                </span>);
            else if (location[0] === 'Hybrid')
                icon.push(<React.Fragment><span id='hybrid'> <LocationCityIcon /><CloudOutlinedIcon style={{ marginLeft: '.2em' }} /></span>
                    <UncontrolledTooltip delay={{ show: 0, hide: 0 }} target='hybrid'>On Premise & Virtual</UncontrolledTooltip>
                </React.Fragment>
                    );
                
            const eventTitle = event.title;
            return (
                <React.Fragment>
                    <span style={{ paddingRight: '1.3em' }}>
                        {eventTitle}
                    </span>
                    <span>
                        {icon}
                    </span>
                    <Button id='deleteTraining' style={{
                        padding: '2px 1px', backgroundColor: 'transparent', borderColor: 'transparent', position: 'relative', bottom: '15px',
                        height: '.3em', marginLeft: '.3em'
                    }} onClick={() => this.toggleDeleteModal(event.event)}><DeleteIcon />
                    </Button>
                    <UncontrolledTooltip delay={{ show: 0, hide: 0 }} target='deleteTraining'>Delete Training</UncontrolledTooltip>
                </React.Fragment>
            )
        }
        return (
            <React.Fragment>
                <Input style={{ width: '15em' }} name='calendarDate' type="month" value={moment(this.state.selectedDay).format('YYYY-MM')} size="3" onChange={this.handleCalendarChange} />
                <Container className='calContainer'>
                    <Calendar
                        components={{
                            event: CustomEvent
                        }}
                        localizer={localizer}
                        events={events.toJS()}
                        startAccessor="start"
                        endAccessor="end"
                        selectable={true}
                        onDoubleClickEvent={this.handleSelect}
                        onSelectSlot={this.handleAdd}
                        date={this.state.selectedDay}
                        onNavigate={date => {
                            const fromCalender = true;
                            this.handleCalendarChange(moment(date), fromCalender);
                        }}
                    />
                    <DeleteConfirmation
                        title={`Delete Training`}
                        onDelete={this.handleDelete}
                        isOpen={this.state.showDeleteConfirmation}
                        onToggle={this.toggleDeleteModal}
                        toDelete={this.state.toDelete}
                    />
                </Container>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        trainings: state.Trainings.get('list'),
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators({ ...staticDataActions, ...actions, getSessions, getTrainingFaculty }, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(Trainings);
